var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var Svg4 = function Svg4(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "62px",
    height: "45px",
    viewBox: "0 0 62 45",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Zendesk main") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.580759946 0 15.940353 0 15.940353 7.67963866 0.580759946 7.67963866"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0.120603588 0 15.478618 0 15.478618 18.5428016 0.120603588 18.5428016"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-5",
    points: "0.214687015 0.44041808 6.74211941 0.44041808 6.74211941 8.48487282 0.214687015 8.48487282"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Zendesk-main",
    transform: "translate(0.616115, 0.733382)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#03363D",
    points: "28.5690009 6.65545531 28.5690009 25.1974676 13.2094079 25.1974676"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-25",
    transform: "translate(0.000000, -0.000158)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(12.628648, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.940353,-0.000157858099 C15.940353,4.24148926 12.5022036,7.67963866 8.26055647,7.67963866 C4.01890934,7.67963866 0.580759946,4.24148926 0.580759946,-0.000157858099 L15.940353,-0.000157858099 Z",
    id: "Fill-2",
    fill: "#03363D",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M31.1002555,25.1977833 C31.1002555,20.9561362 34.5384049,17.5179868 38.780052,17.5179868 C43.0216992,17.5179868 46.45827,20.9561362 46.45827,25.1977833 L31.1002555,25.1977833 Z",
    id: "Fill-5",
    fill: "#03363D"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(30.979652, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-8"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-7",
    fill: "#03363D",
    mask: "url(#mask-4)",
    points: "0.120603588 18.5428016 0.120603588 -0.000789290495 15.478618 -0.000789290495"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M41.5212579,37.9411941 C41.3586641,36.8945949 40.733546,36.1242474 39.4833099,36.1242474 C38.3214743,36.1242474 37.516398,36.7840942 37.301711,37.9411941 L41.5212579,37.9411941 Z M39.6790539,41.0620487 C40.6625099,41.0620487 41.3776071,40.657932 41.8069811,40.2348723 L42.8630518,41.3730292 C42.1637404,42.089705 41.1992274,42.6216867 39.6979969,42.6216867 C37.1233313,42.6216867 35.4595069,40.9152407 35.4595069,38.601041 C35.4595069,36.3073628 37.2133104,34.5819738 39.4643669,34.5819738 C42.0200895,34.5819738 43.4692269,36.5267855 43.344519,39.226159 L37.301711,39.226159 C37.516398,40.345373 38.3025313,41.0620487 39.6790539,41.0620487 L39.6790539,41.0620487 Z",
    id: "Fill-10",
    fill: "#03363D"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-12",
    fill: "#03363D",
    points: "0.000315716198 40.9774368 4.65081531 36.2527439 0.107659224 36.2527439 0.107659224 34.7704563 6.80715695 34.7704563 6.80715695 36.2827369 2.15507877 41.0090084 6.86872161 41.0090084 6.86872161 42.4897174 0.000315716198 42.4897174"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9331873,37.9411941 C13.7705934,36.8945949 13.1454753,36.1242474 11.8936606,36.1242474 C10.731825,36.1242474 9.92832728,36.7840942 9.71364027,37.9411941 L13.9331873,37.9411941 Z M12.0909832,41.0620487 C13.0744392,41.0620487 13.7895364,40.657932 14.2189104,40.2348723 L15.2734025,41.3730292 C14.5756697,42.089705 13.6111567,42.6216867 12.1099262,42.6216867 C9.53368203,42.6216867 7.87143625,40.9152407 7.87143625,38.601041 C7.87143625,36.3073628 9.62523973,34.5819738 11.8762962,34.5819738 C14.4320188,34.5819738 15.8811562,36.5267855 15.7548697,39.226159 L9.71364027,39.226159 C9.92832728,40.345373 10.7144606,41.0620487 12.0909832,41.0620487 L12.0909832,41.0620487 Z",
    id: "Fill-14",
    fill: "#03363D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.341178,38.5910959 C32.341178,37.2177304 31.3024718,36.0906236 29.8912203,36.0906236 C28.5115406,36.0906236 27.4412627,37.1861588 27.4412627,38.5910959 C27.4412627,39.996033 28.5115406,41.1089326 29.8912203,41.1089326 C31.3024718,41.1089326 32.341178,39.9802472 32.341178,38.5910959 M25.7979598,38.6068817 C25.7979598,36.1364025 27.6417424,34.5909717 29.6749548,34.5909717 C30.6978752,34.5909717 31.6750169,35.0392887 32.2480418,35.7496501 L32.2480418,31.1938654 L33.8913446,31.1938654 L33.8913446,42.4680908 L32.2480418,42.4680908 L32.2480418,41.4009701 C31.6592311,42.1586889 30.6820894,42.6212132 29.6591689,42.6212132 C27.6906784,42.6212132 25.7979598,41.0615752 25.7979598,38.6068817",
    id: "Fill-16",
    fill: "#03363D"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-20",
    transform: "translate(44.200268, 34.136814)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.214687015,6.69334126 L1.70171031,5.92141515 C2.12161285,6.6317766 2.80355984,7.04852198 3.68756519,7.04852198 C4.6173494,7.04852198 5.0988166,6.57021194 5.0988166,6.03033724 C5.0988166,5.41153349 4.19902544,5.27261837 3.2218838,5.07213858 C1.90376867,4.79430833 0.539874699,4.36177714 0.539874699,2.77214608 C0.539874699,1.55190297 1.70171031,0.424796145 3.53286426,0.440581954 C4.9741087,0.440581954 6.04280803,1.01044969 6.64898313,1.93707673 L5.26772477,2.69479561 C4.91254404,2.15334233 4.30794752,1.81394742 3.53286426,1.81394742 C2.6488589,1.81394742 2.19896332,2.24647861 2.19896332,2.74057446 C2.19896332,3.29623497 2.91248193,3.4509359 4.02853869,3.69719454 C5.30087497,3.97502479 6.74211941,4.39177017 6.74211941,5.99876562 C6.74211941,7.06430779 5.81233521,8.50081649 3.60863614,8.48503068 C1.99690495,8.48503068 0.865062383,7.8362339 0.214687015,6.69334126",
    id: "Fill-18",
    fill: "#03363D",
    mask: "url(#mask-6)"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-21",
    fill: "#03363D",
    points: "55.4048778 39.0387815 54.1025484 40.4595044 54.1025484 42.4674594 52.4592456 42.4674594 52.4592456 31.1948125 54.1025484 31.1948125 54.1025484 38.5762572 57.5912124 34.7466198 59.5912745 34.7466198 56.5667134 38.0505898 59.668625 42.4674594 57.807478 42.4674594"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.831744,34.590656 C18.8790394,34.590656 17.2436295,35.8566779 17.2436295,37.9561906 L17.2436295,42.4661965 L18.9169253,42.4661965 L18.9169253,38.1661419 C18.9169253,36.8985414 19.6446511,36.1408225 20.8854158,36.1408225 C22.1246019,36.1408225 22.7465628,36.8985414 22.7465628,38.1661419 L22.7465628,42.4661965 L24.4214372,42.4661965 L24.4214372,37.9561906 C24.4214372,35.8566779 22.7844487,34.590656 20.831744,34.590656",
    id: "Fill-23",
    fill: "#03363D"
  }))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(Svg4);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/4.d6063105150c332286cab26b00a58c83.svg";